import { EntityState } from '@reduxjs/toolkit';

import { RootState } from '@app/store';
import { CancelReasonItem, EventListItem } from '@app/gen/events';

import { BatchTotal } from '../types';

export interface EventsActionsState {
  events: EventListItem[];
  total: number;
  eventTags: string[];
  batchTotal?: BatchTotal | null;
  cancelReasons: CancelReasonItem[];
}

export const initialState: EventsActionsState = {
  events: [],
  total: 0,
  eventTags: [],
  batchTotal: null,
  cancelReasons: [],
};

export interface EventsActionsRootState extends RootState {
  eventsActions: EventsActionsState & EntityState<EventListItem, string>;
}
